"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { SVGIcon } from "./SVGIcon";
import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @donotoptimize cup handle neck is widened
 */
export const InactiveTrophy = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9747 16.8534C18.4826 15.3989 19.3249 13.4186 19.3249 11.3592V0.864502H3.28784V11.3592C3.28784 13.4186 4.12332 15.3989 5.63124 16.8534C6.71617 17.9 8.07536 18.6185 9.54437 18.9392C7.83784 19.4509 6.49678 20.6863 5.96067 22.2471H16.652C16.1156 20.6908 14.7688 19.4522 13.0621 18.9394C14.5329 18.6187 15.8945 17.9001 16.9747 16.8534Z"
      stroke="currentColor"
    />
    <path
      d="M11.4367 4.35344L12.4013 6.85691C12.4285 6.92653 12.5023 6.96333 12.5721 6.94145L15.0835 6.15272C15.2048 6.11492 15.3087 6.2482 15.2456 6.36059L13.9365 8.69597C13.9006 8.76062 13.9191 8.84317 13.9782 8.88594L16.1452 10.4067C16.25 10.4803 16.2131 10.6464 16.0869 10.6663L13.4911 11.0731C13.4193 11.0841 13.3679 11.1507 13.3727 11.2253L13.5639 13.9098C13.5736 14.0391 13.4232 14.1137 13.33 14.0252L11.4008 12.198C11.3475 12.1473 11.265 12.1473 11.2116 12.198L9.28243 14.0252C9.18927 14.1137 9.03886 14.0391 9.04856 13.9098L9.23973 11.2253C9.24458 11.1507 9.19315 11.085 9.12134 11.0731L6.52452 10.6663C6.39934 10.6464 6.36246 10.4803 6.4663 10.4067L8.63322 8.88594C8.69339 8.84416 8.71183 8.76161 8.67495 8.69597L7.36781 6.36159C7.30473 6.24919 7.40857 6.11492 7.52987 6.15371L10.0413 6.94245C10.1112 6.96433 10.1859 6.92753 10.2121 6.8579L11.1767 4.35444C11.2233 4.23309 11.3902 4.23309 11.4367 4.35344Z"
      stroke="currentColor"
    />
  </>,
  "InactiveTrophyIcon",
  {
    // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
    viewBox: "0 0 22 23",
    fill: "none",
    color: "#888888",
    className: legacyIconCls(),
  }
);

/**
 * @donotoptimize cup handle neck is widened
 */
export const ActiveTrophy = createSVGIcon(
  <>
    <mask
      id="path-1-outside-1"
      maskUnits="userSpaceOnUse"
      x="2.42419"
      y="0.144409"
      width="28"
      height="36"
      fill="black"
    >
      <rect fill="white" x="2.42419" y="0.144409" width="28" height="36" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7386 25.8757C26.9767 23.7168 28.2269 20.7777 28.2269 17.721V2.14441H4.42419V17.721C4.42419 20.7777 5.66423 23.7168 7.90235 25.8757C9.51267 27.429 11.5301 28.4955 13.7105 28.9715C11.1775 29.7309 9.18703 31.5645 8.39131 33.8813H24.2597C23.4636 31.5713 21.4645 29.7329 18.9313 28.9717C21.1144 28.4958 23.1353 27.4292 24.7386 25.8757Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7386 25.8757C26.9767 23.7168 28.2269 20.7777 28.2269 17.721V2.14441H4.42419V17.721C4.42419 20.7777 5.66423 23.7168 7.90235 25.8757C9.51267 27.429 11.5301 28.4955 13.7105 28.9715C11.1775 29.7309 9.18703 31.5645 8.39131 33.8813H24.2597C23.4636 31.5713 21.4645 29.7329 18.9313 28.9717C21.1144 28.4958 23.1353 27.4292 24.7386 25.8757Z"
      fill="#8B9478"
    />
    <path
      d="M24.7386 25.8757L23.3501 24.4362L23.3469 24.4394L24.7386 25.8757ZM28.2269 2.14441H30.2269V0.144409H28.2269V2.14441ZM4.42419 2.14441V0.144409H2.42419V2.14441H4.42419ZM7.90235 25.8757L6.51383 27.3151H6.51383L7.90235 25.8757ZM13.7105 28.9715L14.2849 30.8873L21.691 28.6669L14.1371 27.0176L13.7105 28.9715ZM8.39131 33.8813L6.49977 33.2316L5.58969 35.8813H8.39131V33.8813ZM24.2597 33.8813V35.8813H27.0646L26.1506 33.2295L24.2597 33.8813ZM18.9313 28.9717L18.5053 27.0176L10.9557 28.6636L18.3558 30.8871L18.9313 28.9717ZM26.2269 17.721C26.2269 20.2291 25.2016 22.6503 23.3501 24.4362L26.1271 27.3151C28.7519 24.7833 30.2269 21.3263 30.2269 17.721H26.2269ZM26.2269 2.14441V17.721H30.2269V2.14441H26.2269ZM4.42419 4.14441H28.2269V0.144409H4.42419V4.14441ZM6.42419 17.721V2.14441H2.42419V17.721H6.42419ZM9.29086 24.4362C7.44263 22.6534 6.42419 20.2335 6.42419 17.721H2.42419C2.42419 21.3218 3.88583 24.7801 6.51383 27.3151L9.29086 24.4362ZM14.1371 27.0176C12.3124 26.6192 10.6298 25.7278 9.29086 24.4362L6.51383 27.3151C8.39558 29.1303 10.7477 30.3718 13.2839 30.9255L14.1371 27.0176ZM13.1361 27.0558C10.0458 27.9823 7.52445 30.2483 6.49977 33.2316L10.2828 34.5309C10.8496 32.8808 12.3093 31.4796 14.2849 30.8873L13.1361 27.0558ZM8.39131 35.8813H24.2597V31.8813H8.39131V35.8813ZM26.1506 33.2295C25.1246 30.2527 22.5944 27.984 19.5069 27.0563L18.3558 30.8871C20.3347 31.4817 21.8026 32.8899 22.3689 34.533L26.1506 33.2295ZM23.3469 24.4394C22.0178 25.7272 20.3339 26.6189 18.5053 27.0176L19.3574 30.9258C21.8949 30.3726 24.2529 29.1313 26.1304 27.312L23.3469 24.4394Z"
      fill="white"
      mask="url(#path-1-outside-1)"
    />
    <path
      d="M16.5194 7.32299L17.9511 11.0387C17.9915 11.1421 18.1009 11.1967 18.2046 11.1642L21.9322 9.99353C22.1122 9.93743 22.2663 10.1353 22.1727 10.3021L20.2297 13.7683C20.1764 13.8643 20.2038 13.9868 20.2916 14.0503L23.5079 16.3075C23.6634 16.4167 23.6087 16.6632 23.4214 16.6928L19.5686 17.2965C19.462 17.3128 19.3857 17.4117 19.3929 17.5224L19.6766 21.5068C19.691 21.6987 19.4678 21.8094 19.3295 21.6781L16.4662 18.9662C16.3869 18.8909 16.2645 18.8909 16.1853 18.9662L13.322 21.6781C13.1837 21.8094 12.9604 21.6987 12.9748 21.5068L13.2586 17.5224C13.2658 17.4117 13.1894 17.3143 13.0829 17.2965L9.22858 16.6928C9.04278 16.6632 8.98805 16.4167 9.14216 16.3075L12.3584 14.0503C12.4477 13.9883 12.475 13.8657 12.4203 13.7683L10.4802 10.3035C10.3866 10.1367 10.5407 9.93743 10.7207 9.99501L14.4483 11.1657C14.552 11.1982 14.6629 11.1435 14.7018 11.0402L16.1334 7.32447C16.2026 7.14437 16.4503 7.14437 16.5194 7.32299Z"
      fill="white"
    />
  </>,
  "ActiveTrophyIcon",
  {
    // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
    viewBox: "0 0 33 36",
    fill: "none",
    className: legacyIconCls(),
  }
);

export const TrophyIcon = React.memo(
  ({
    active,
    ...props
  }: SVGIcon.IProps & {
    active?: boolean;
  } & React.RefAttributes<SVGElement>) => {
    return active ? <ActiveTrophy {...props} /> : <InactiveTrophy {...props} />;
  }
);

/** @optimized using svgo:^3.0.2 */
export const InactiveTrophySecondary = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.577 11.57a5.43 5.43 0 0 0 1.645-3.888V.254H0v7.428c0 1.457.584 2.859 1.64 3.888.759.741 1.71 1.25 2.737 1.477-1.194.362-2.132 1.236-2.507 2.34h7.481c-.375-1.1-1.317-1.977-2.511-2.34a5.65 5.65 0 0 0 2.737-1.477"
      fill="currentColor"
    />
    <path
      d="m5.702 2.723.675 1.772c.02.05.071.075.12.06l1.757-.559c.085-.026.158.068.114.148l-.916 1.652a.105.105 0 0 0 .029.135l1.516 1.076c.074.052.048.17-.04.184L7.14 7.48a.1.1 0 0 0-.083.108l.134 1.9c.007.091-.099.144-.164.081l-1.35-1.293a.095.095 0 0 0-.132 0l-1.35 1.293c-.065.063-.17.01-.164-.081l.134-1.9a.1.1 0 0 0-.083-.108l-1.817-.288c-.087-.014-.113-.132-.04-.184L3.74 5.931a.103.103 0 0 0 .029-.135l-.915-1.652c-.044-.08.029-.174.114-.147l1.757.558a.097.097 0 0 0 .12-.06l.674-1.771a.097.097 0 0 1 .182-.001"
      fill="#fff"
    />
  </>,
  "InactiveTrophyIconSecondary",
  {
    // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
    viewBox: "0 0 12 16",
    fill: "none",
    color: "#CCCCCC",
    className: legacyIconCls(),
  }
);

/** @optimized using svgo:^3.0.2 */
export const ActiveTrophySecondary = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.241 11.964A5.7 5.7 0 0 0 14 7.853V0H2v7.853c0 1.54.625 3.023 1.753 4.111a6.1 6.1 0 0 0 2.929 1.56C5.405 13.909 4.402 14.833 4 16h8c-.401-1.165-1.41-2.091-2.686-2.475 1.1-.24 2.12-.778 2.927-1.561"
      fill="#fff"
    />
    <path
      d="m8.098 2.61.721 1.874c.02.052.076.08.128.063l1.88-.59c.09-.029.168.071.12.155L9.969 5.86a.11.11 0 0 0 .031.142l1.622 1.138c.078.055.05.18-.044.194l-1.942.305a.107.107 0 0 0-.089.113l.143 2.01c.008.096-.105.152-.175.085L8.071 8.48a.1.1 0 0 0-.142 0L6.486 9.847c-.07.067-.183.01-.175-.086l.143-2.009a.11.11 0 0 0-.089-.113l-1.943-.305c-.094-.015-.121-.139-.043-.194l1.62-1.138a.11.11 0 0 0 .032-.142l-.978-1.747c-.047-.084.03-.185.121-.156l1.88.59a.104.104 0 0 0 .127-.063l.722-1.873c.035-.09.16-.09.195 0"
      fill="currentColor"
    />
  </>,
  "ActiveTrophyIconSecondary",
  {
    // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
    viewBox: "0 0 16 16",
    fill: "none",
    color: "#8B9478",
    className: legacyIconCls(),
  }
);

export const TrophyIconSecondary = React.memo(
  ({
    active,
    ...props
  }: SVGIcon.IProps & {
    active?: boolean;
  } & React.RefAttributes<SVGElement>) => {
    return active ? (
      <ActiveTrophySecondary {...props} />
    ) : (
      <InactiveTrophySecondary {...props} />
    );
  }
);
